import React from 'react'
import {
    List,
    Edit,
    DateField,
    ReferenceField,
    BooleanField,
    SimpleForm,
    NumberField,
    Datagrid,
    TextField,
    Show,
} from 'react-admin'

export const transactionTransactionPaymentShow = ({ ...props }) => (
    <Show {...props}>
        <SimpleForm>
            <TextField source="id" />
            <DateField source="created" />
            <DateField source="updated" />
            <ReferenceField
                source="transactionId"
                reference="transaction/transaction"
            >
                <TextField source="id" />
            </ReferenceField>
            <NumberField source="amount" />
            <TextField source="paymentType" />
            <NumberField source="refundedAmount" />
            <TextField source="currency" />
        </SimpleForm>
    </Show>
)

export const transactionTransactionPaymentList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <DateField source="created" />
                <DateField source="updated" />
                <ReferenceField
                    source="transactionId"
                    reference="transaction/transaction"
                >
                    <TextField source="id" />
                </ReferenceField>
                <NumberField source="amount" />
                <TextField source="paymentType" />
                <NumberField source="refundedAmount" />
                <TextField source="currency" />
            </Datagrid>
        </List>
    )
}
